{
  "identities.messages.1010001": "ចូល",
  "identities.messages.1010002": "ចូលជាមួយ {provider}",
  "identities.messages.1010003": "សូមបញ្ជាក់សកម្មភាពនេះដោយផ្ទៀងផ្ទាត់ថាវាជាអ្នក។",
  "identities.messages.1010004": "សូមបំពេញការប្រកួតផ្ទៀងផ្ទាត់ទីពីរ។",
  "identities.messages.1010005": "ផ្ទៀងផ្ទាត់",
  "identities.messages.1010006": "លេខកូដផ្ទៀងផ្ទាត់",
  "identities.messages.1010007": "លេខកូដស្តារបម្រុង",
  "identities.messages.1010008": "បន្តជាមួយកូនសោរផ្នែករឹង",
  "identities.messages.1010009": "បន្ត",
  "identities.messages.1010010": "បន្ត",
  "identities.messages.1010011": "ចូលជាមួយកូនសោរផ្នែករឹង",
  "identities.messages.1010012": "រៀបចំឧបករណ៍ WebAuthn របស់អ្នក (ឧទាហរណ៍ កូនសោរសុវត្ថិភាព ឧបករណ៍វាស់ជីវមាត្រ ...) ហើយចុចបន្ត។",
  "identities.messages.1010013": "បន្ត",
  "identities.messages.1010014": "លេខកូដត្រូវបានផ្ញើទៅអាសយដ្ឋានដែលអ្នកបានផ្តល់។ ប្រសិនបើអ្នកមិនទទួលបាន សូមពិនិត្យអក្ខរាវិរុទ្ធនៃអាសយដ្ឋាន ហើយព្យាយាមម្តងទៀត។",
  "identities.messages.1010015": "ផ្ញើលេខកូដចូល",
  "identities.messages.1010016": "អ្នកបានព្យាយាមចូលដោយប្រើ \"{duplicateIdentifier}\" ប៉ុន្តែអ៊ីមែលនោះត្រូវបានប្រើរួចហើយដោយគណនីផ្សេង។ ចូលទៅគណនីរបស់អ្នកដោយប្រើជម្រើសមួយខាងក្រោមដើម្បីបន្ថែមគណនីរបស់អ្នក \"{duplicateIdentifier}\" នៅ \"{provider}\" ជាវិធីចូលមួយទៀត។",
  "identities.messages.1010017": "ចូលនិងភ្ជាប់",
  "identities.messages.1010018": "បញ្ជាក់ជាមួយ {provider}",
  "identities.messages.1010019": "ស្នើសុំលេខកូដដើម្បីបន្ត",
  "identities.messages.1010021": "ចូលជាមួយ passkey",
  "identities.messages.1010022": "ចូលជាមួយពាក្យសម្ងាត់",
  "identities.messages.1010023": "ផ្ញើលេខកូដទៅ {address}",
  "identities.messages.1040001": "ចុះឈ្មោះ",
  "identities.messages.1040002": "ចុះឈ្មោះជាមួយ {provider}",
  "identities.messages.1040003": "បន្ត",
  "identities.messages.1040004": "ចុះឈ្មោះជាមួយកូនសោរសុវត្ថិភាព",
  "identities.messages.1040005": "លេខកូដត្រូវបានផ្ញើទៅអាសយដ្ឋានដែលអ្នកបានផ្តល់។ ប្រសិនបើអ្នកមិនបានទទួលសារ សូមពិនិត្យអក្ខរាវិរុទ្ធនៃអាសយដ្ឋាន ហើយព្យាយាមចុះឈ្មោះម្តងទៀត។",
  "identities.messages.1040006": "ផ្ញើលេខកូដចុះឈ្មោះ",
  "identities.messages.1040007": "ចុះឈ្មោះជាមួយ passkey",
  "identities.messages.1040008": "ត្រឡប់ក្រោយ",
  "identities.messages.1040009": "សូមជ្រើសរើសលិខិតសម្គាល់ដើម្បីផ្ទៀងផ្ទាត់ខ្លួនអ្នក។",
  "identities.messages.1050001": "ការផ្លាស់ប្តូររបស់អ្នកត្រូវបានរក្សាទុក!",
  "identities.messages.1050002": "ភ្ជាប់ {provider}",
  "identities.messages.1050003": "ផ្តាច់ {provider}",
  "identities.messages.1050004": "ផ្តាច់កម្មវិធីផ្ទៀងផ្ទាត់ TOTP",
  "identities.messages.1050005": "លេខកូដ QR កម្មវិធីផ្ទៀងផ្ទាត់",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "បង្ហាញលេខកូដស្តារបម្រុង",
  "identities.messages.1050008": "បើក",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "នេះគឺជាលេខកូដស្តារបម្រុងរបស់អ្នក។ សូមរក្សាវានៅកន្លែងសុវត្ថិភាព!",
  "identities.messages.1050011": "បញ្ជាក់លេខកូដស្តារបម្រុង",
  "identities.messages.1050012": "បន្ថែមកូនសោរសុវត្ថិភាព",
  "identities.messages.1050013": "ឈ្មោះកូនសោរសុវត្ថិភាព",
  "identities.messages.1050014": "លេខសម្ងាត់ត្រូវបានប្រើនៅ {used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "បិទវិធីសាស្រ្តនេះ",
  "identities.messages.1050017": "លេខសម្ងាត់ផ្ទៀងផ្ទាត់",
  "identities.messages.1050018": "លុបកូនសោរសុវត្ថិភាព \"{display_name}\"",
  "identities.messages.1050019": "បន្ថែម passkey",
  "identities.messages.1050020": "លុប passkey \"{display_name}\"",
  "identities.messages.1060001": "អ្នកបានស្តារគណនីរបស់អ្នកដោយជោគជ័យ។ សូមផ្លាស់ប្តូរពាក្យសម្ងាត់ ឬដំឡើងវិធីចូលជំនួសក្នុងរយៈពេល {privileged_session_expires_at_unix_until_minutes} នាទីបន្ទាប់។",
  "identities.messages.1060002": "អ៊ីមែលដែលមានតំណស្តារត្រូវបានផ្ញើទៅអាសយដ្ឋានអ៊ីមែលដែលអ្នកបានផ្តល់។ ប្រសិនបើអ្នកមិនបានទទួលអ៊ីមែល សូមពិនិត្យអក្ខរាវិរុទ្ធនៃអាសយដ្ឋាន ហើយប្រាកដថាប្រើអាសយដ្ឋានដែលអ្នកបានចុះឈ្មោះ។",
  "identities.messages.1060003": "អ៊ីមែលដែលមានលេខកូដស្តារត្រូវបានផ្ញើទៅអាសយដ្ឋានអ៊ីមែលដែលអ្នកបានផ្តល់។ ប្រសិនបើអ្នកមិនបានទទួលអ៊ីមែល សូមពិនិត្យអក្ខរាវិរុទ្ធនៃអាសយដ្ឋាន ហើយប្រាកដថាប្រើអាសយដ្ឋានដែលអ្នកបានចុះឈ្មោះ។",
  "identities.messages.1060004": "លេខកូដស្តារត្រូវបានផ្ញើទៅ \"{masked_address}\"។ ប្រសិនបើអ្នកមិនបានទទួល សូមពិនិត្យអក្ខរាវិរុទ្ធនៃអាសយដ្ឋាន ហើយប្រាកដថាប្រើអាសយដ្ឋានដែលអ្នកបានចុះឈ្មោះ។",
  "identities.messages.1060005": "ស្តារការចូលទៅគណនីរបស់អ្នកដោយផ្តល់អាសយដ្ឋានស្តារពេញលេញ។",
  "identities.messages.1060006": "តើអ្នកចង់ស្តារគណនីរបស់អ្នកដោយរបៀបណា?",
  "identities.messages.1060007": "ត្រឡប់ក្រោយ",
  "identities.messages.1070001": "ពាក្យសម្ងាត់",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "រក្សាទុក",
  "identities.messages.1070004": "លេខសម្គាល់",
  "identities.messages.1070005": "ដាក់ស្នើ",
  "identities.messages.1070006": "ផ្ទៀងផ្ទាត់លេខកូដ",
  "identities.messages.1070007": "អ៊ីមែល",
  "identities.messages.1070008": "ផ្ញើលេខកូដម្តងទៀត",
  "identities.messages.1070009": "បន្ត",
  "identities.messages.1070010": "លេខកូដស្តារ",
  "identities.messages.1070011": "លេខកូដផ្ទៀងផ្ទាត់",
  "identities.messages.1070012": "លេខកូដចុះឈ្មោះ",
  "identities.messages.1070013": "លេខកូដចូល",
  "identities.messages.1070014": "ចូលនិងភ្ជាប់លិខិតសម្គាល់",
  "identities.messages.1070015": "សូមបំពេញការប្រកួត captcha ដើម្បីបន្ត។",
  "identities.messages.1070016": "អាសយដ្ឋានស្តារ",
  "identities.messages.1070017": "លេខទូរស័ព្ទ",
  "identities.messages.1080001": "អ៊ីមែលដែលមានតំណផ្ទៀងផ្ទាត់ត្រូវបានផ្ញើទៅអាសយដ្ឋានអ៊ីមែលដែលអ្នកបានផ្តល់។ ប្រសិនបើអ្នកមិនបានទទួលអ៊ីមែល សូមពិនិត្យអក្ខរាវិរុទ្ធនៃអាសយដ្ឋាន ហើយប្រាកដថាប្រើអាសយដ្ឋានដែលអ្នកបានចុះឈ្មោះ។",
  "identities.messages.1080002": "អ្នកបានផ្ទៀងផ្ទាត់អាសយដ្ឋានអ៊ីមែលរបស់អ្នកដោយជោគជ័យ។",
  "identities.messages.1080003": "អ៊ីមែលដែលមានលេខកូដផ្ទៀងផ្ទាត់ត្រូវបានផ្ញើទៅអាសយដ្ឋានអ៊ីមែលដែលអ្នកបានផ្តល់។ ប្រសិនបើអ្នកមិនបានទទួលអ៊ីមែល សូមពិនិត្យអក្ខរាវិរុទ្ធនៃអាសយដ្ឋាន ហើយប្រាកដថាប្រើអាសយដ្ឋានដែលអ្នកបានចុះឈ្មោះ។",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "សូមបញ្ចូល {property} ហើយព្យាយាមម្តងទៀត។",
  "identities.messages.4000003": "ប្រវែងត្រូវតែ >= {min_length} ប៉ុន្តែបានទទួល {actual_length}",
  "identities.messages.4000004": "មិនត្រូវគ្នានឹងលំនាំ \"{pattern}\"",
  "identities.messages.4000005": "ពាក្យសម្ងាត់មិនអាចប្រើបានទេដោយសារតែ {reason}។",
  "identities.messages.4000006": "លិខិតសម្គាល់ដែលបានផ្តល់មិនត្រឹមត្រូវទេ សូមពិនិត្យកំហុសអក្ខរាវិរុទ្ធក្នុងពាក្យសម្ងាត់ ឈ្មោះអ្នកប្រើ អាសយដ្ឋានអ៊ីមែល ឬលេខទូរស័ព្ទរបស់អ្នក។",
  "identities.messages.4000007": "គណនីដែលមានលេខសម្គាល់ដូចគ្នា (អ៊ីមែល ទូរស័ព្ទ ឈ្មោះអ្នកប្រើ ...) មានរួចហើយ។",
  "identities.messages.4000008": "លេខកូដផ្ទៀងផ្ទាត់ដែលបានផ្តល់មិនត្រឹមត្រូវទេ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4000009": "មិនរកឃើញលេខសម្គាល់ចូលណាមួយទេ។ តើអ្នកភ្លេចកំណត់វាទេ? នេះក៏អាចបណ្តាលមកពីការកំណត់រចនាសម្ព័ន្ធម៉ាស៊ីនមេមិនត្រឹមត្រូវផងដែរ។",
  "identities.messages.4000010": "គណនីនៅមិនទាន់សកម្ម។ តើអ្នកភ្លេចផ្ទៀងផ្ទាត់អាសយដ្ឋានអ៊ីមែលរបស់អ្នកទេ?",
  "identities.messages.4000011": "អ្នកមិនមានឧបករណ៍ TOTP ដែលបានដំឡើងទេ។",
  "identities.messages.4000012": "លេខកូដស្តារបម្រុងនេះត្រូវបានប្រើរួចហើយ។",
  "identities.messages.4000013": "អ្នកមិនមានឧបករណ៍ WebAuthn ដែលបានដំឡើងទេ។",
  "identities.messages.4000014": "អ្នកមិនមានលេខកូដស្តារបម្រុងដែលបានដំឡើងទេ។",
  "identities.messages.4000015": "គណនីនេះមិនមានទេ ឬមិនមានកូនសោរសុវត្ថិភាពដែលបានដំឡើងទេ។",
  "identities.messages.4000016": "លេខកូដស្តារបម្រុងមិនត្រឹមត្រូវទេ។",
  "identities.messages.4000017": "ប្រវែងត្រូវតែ <= {max_length} ប៉ុន្តែបានទទួល {actual_length}",
  "identities.messages.4000018": "ត្រូវតែ >= {minimum} ប៉ុន្តែបានរក {actual}",
  "identities.messages.4000019": "ត្រូវតែ > {minimum} ប៉ុន្តែបានរក {actual}",
  "identities.messages.4000020": "ត្រូវតែ <= {maximum} ប៉ុន្តែបានរក {actual}",
  "identities.messages.4000021": "ត្រូវតែ < {maximum} ប៉ុន្តែបានរក {actual}",
  "identities.messages.4000022": "{actual} មិនជាពហុគុណនៃ {base}",
  "identities.messages.4000023": "អនុញ្ញាតអតិបរមា {max_items} ធាតុ ប៉ុន្តែបានរក {actual_items} ធាតុ",
  "identities.messages.4000024": "អនុញ្ញាតអប្បបរមា {min_items} ធាតុ ប៉ុន្តែបានរក {actual_items} ធាតុ",
  "identities.messages.4000025": "ធាតុនៅសន្ទស្សន៍ {index_a} និង {index_b} ដូចគ្នា",
  "identities.messages.4000026": "រំពឹងទុក {allowed_types_list} ប៉ុន្តែបានទទួល {actual_type}",
  "identities.messages.4000027": "គណនីដែលមានលេខសម្គាល់ដូចគ្នា (អ៊ីមែល ទូរស័ព្ទ ឈ្មោះអ្នកប្រើ ...) មានរួចហើយ។ សូមចូលទៅគណនីដែលមានរួចហើយរបស់អ្នកដើម្បីភ្ជាប់ប្រវត្តិរូបសង្គមរបស់អ្នក។",
  "identities.messages.4000028": "អ្នកបានព្យាយាមចូលដោយប្រើ {credential_identifier_hint} ដែលកំពុងប្រើដោយគណនីផ្សេងរួចហើយ។ អ្នកអាចចូលដោយប្រើ {available_credential_types_list}។ អ្នកអាចចូលដោយប្រើអ្នកផ្តល់សេវាចូលសង្គមដូចខាងក្រោម៖ {available_oidc_providers_list}។",
  "identities.messages.4000029": "ត្រូវតែស្មើនឹងថេរ {expected}",
  "identities.messages.4000030": "ថេរបានបរាជ័យ",
  "identities.messages.4000031": "ពាក្យសម្ងាត់មិនអាចប្រើបានទេដោយសារវាស្រដៀងគ្នានឹងលេខសម្គាល់ពេក។",
  "identities.messages.4000032": "ពាក្យសម្ងាត់ត្រូវតែមានយ៉ាងតិច {min_length} តួអក្សរ ប៉ុន្តែបានទទួល {actual_length}។",
  "identities.messages.4000033": "ពាក្យសម្ងាត់ត្រូវតែមានអតិបរមា {max_length} តួអក្សរ ប៉ុន្តែបានទទួល {actual_length}។",
  "identities.messages.4000034": "ពាក្យសម្ងាត់ត្រូវបានរកឃើញក្នុងការលេចធ្លាយទិន្នន័យ ហើយមិនអាចប្រើបានទៀតទេ។",
  "identities.messages.4000035": "គណនីនេះមិនមានទេ ឬមិនបានដំឡើងការចូលដោយលេខកូដទេ។",
  "identities.messages.4000036": "លក្ខណៈដែលបានផ្តល់មិនត្រូវគ្នានឹងលក្ខណៈដែលបានភ្ជាប់មុននឹងលំហូរនេះទេ។",
  "identities.messages.4000037": "គណនីនេះមិនមានទេ ឬមិនមានវិធីចូលដែលបានកំណត់រចនាសម្ព័ន្ធទេ។",
  "identities.messages.4000038": "ការផ្ទៀងផ្ទាត់ Captcha បានបរាជ័យ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4010001": "ការតភ្ជាប់បានផុតកំណត់។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4010002": "មិនរកឃើញយុទ្ធសាស្ត្រសម្រាប់ឲ្យអ្នកចូលបានទេ។ តើអ្នកបានបំពេញទម្រង់ត្រឹមត្រូវទេ?",
  "identities.messages.4010003": "មិនរកឃើញយុទ្ធសាស្ត្រសម្រាប់ឲ្យអ្នកចុះឈ្មោះបានទេ។ តើអ្នកបានបំពេញទម្រង់ត្រឹមត្រូវទេ?",
  "identities.messages.4010004": "មិនរកឃើញយុទ្ធសាស្ត្រសម្រាប់ធ្វើបច្ចុប្បន្នភាពការកំណត់របស់អ្នកបានទេ។ តើអ្នកបានបំពេញទម្រង់ត្រឹមត្រូវទេ?",
  "identities.messages.4010005": "មិនរកឃើញយុទ្ធសាស្ត្រសម្រាប់ស្តារគណនីរបស់អ្នកបានទេ។ តើអ្នកបានបំពេញទម្រង់ត្រឹមត្រូវទេ?",
  "identities.messages.4010006": "មិនរកឃើញយុទ្ធសាស្ត្រសម្រាប់ផ្ទៀងផ្ទាត់គណនីរបស់អ្នកបានទេ។ តើអ្នកបានបំពេញទម្រង់ត្រឹមត្រូវទេ?",
  "identities.messages.4010007": "សំណើត្រូវបានបញ្ចប់ដោយជោគជ័យរួចហើយ ហើយមិនអាចព្យាយាមម្តងទៀតបានទេ។",
  "identities.messages.4010008": "លេខកូដចូលមិនត្រឹមត្រូវ ឬត្រូវបានប្រើរួចហើយ។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4010009": "លិខិតសម្គាល់ដែលបានភ្ជាប់មិនត្រូវគ្នាទេ។",
  "identities.messages.4010010": "អាសយដ្ឋានដែលអ្នកបានបញ្ចូលមិនត្រូវគ្នានឹងអាសយដ្ឋានដែលស្គាល់ណាមួយក្នុងគណនីបច្ចុប្បន្នទេ។",
  "identities.messages.4040001": "ការតភ្ជាប់បានផុតកំណត់។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4040002": "សំណើត្រូវបានបញ្ចប់ដោយជោគជ័យរួចហើយ ហើយមិនអាចព្យាយាមម្តងទៀតបានទេ។",
  "identities.messages.4040003": "លេខកូដចុះឈ្មោះមិនត្រឹមត្រូវ ឬត្រូវបានប្រើរួចហើយ។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4050001": "ការតភ្ជាប់បានផុតកំណត់។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4060001": "សំណើត្រូវបានបញ្ចប់ដោយជោគជ័យរួចហើយ ហើយមិនអាចព្យាយាមម្តងទៀតបានទេ។",
  "identities.messages.4060002": "លំហូរស្តារបានទៅដល់ស្ថានភាពបរាជ័យ ហើយត្រូវតែព្យាយាមម្តងទៀត។",
  "identities.messages.4060004": "និមិត្តសញ្ញាស្តារមិនត្រឹមត្រូវ ឬត្រូវបានប្រើរួចហើយ។ សូមព្យាយាមលំហូរម្តងទៀត។",
  "identities.messages.4060005": "ការតភ្ជាប់បានផុតកំណត់។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4060006": "លេខកូដស្តារមិនត្រឹមត្រូវ ឬត្រូវបានប្រើរួចហើយ។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4070001": "និមិត្តសញ្ញាផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ ឬត្រូវបានប្រើរួចហើយ។ សូមព្យាយាមលំហូរម្តងទៀត។",
  "identities.messages.4070002": "សំណើត្រូវបានបញ្ចប់ដោយជោគជ័យរួចហើយ ហើយមិនអាចព្យាយាមម្តងទៀតបានទេ។",
  "identities.messages.4070003": "លំហូរផ្ទៀងផ្ទាត់បានទៅដល់ស្ថានភាពបរាជ័យ ហើយត្រូវតែព្យាយាមម្តងទៀត។",
  "identities.messages.4070005": "ការតភ្ជាប់បានផុតកំណត់។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4070006": "លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ ឬត្រូវបានប្រើរួចហើយ។ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "ចាកចេញ",
  "login.registration-button": "ចុះឈ្មោះ",
  "login.registration-label": "មិនមានគណនីទេ?",
  "login.title": "ចូល",
  "login.subtitle": "ចូលជាមួយ {parts}",
  "login.title-aal2": "ការផ្ទៀងផ្ទាត់កត្តាទីពីរ",
  "login.subtitle-aal2": "ជ្រើសរើសវិធីបំពេញការផ្ទៀងផ្ទាត់កត្តាទីពីររបស់អ្នក",
  "login.code.subtitle": "លេខកូដផ្ទៀងផ្ទាត់នឹងត្រូវបានផ្ញើតាមអ៊ីមែល",
  "login.webauthn.subtitle": "សូមរៀបចំឧបករណ៍ WebAuthN របស់អ្នក",
  "login.totp.subtitle": "សូមបញ្ចូលលេខកូដដែលបង្កើតដោយកម្មវិធីផ្ទៀងផ្ទាត់របស់អ្នក",
  "login.lookup_secret.subtitle": "សូមបញ្ចូលលេខកូដស្តារបម្រុង 8 ខ្ទង់មួយរបស់អ្នក",
  "login.title-refresh": "ផ្ទៀងផ្ទាត់ម្តងទៀត",
  "login.subtitle-refresh": "បញ្ជាក់អត្តសញ្ញាណរបស់អ្នកជាមួយ {parts}",
  "login.2fa.go-back": "អ្វីមួយមិនដំណើរការទេ?",
  "login.2fa.go-back.link": "ត្រឡប់ក្រោយ",
  "login.2fa.method.go-back": "ជ្រើសរើសវិធីផ្សេង",
  "recovery.title": "ស្តារគណនីរបស់អ្នក",
  "recovery.subtitle": "បញ្ចូលលេខសម្គាល់ដែលភ្ជាប់ជាមួយគណនីរបស់អ្នកដើម្បីទទួលបានលេខកូដចូលមួយដង",
  "registration.login-button": "ចូល",
  "registration.login-label": "មានគណនីរួចហើយ?",
  "registration.title": "ចុះឈ្មោះគណនី",
  "registration.subtitle": "ចុះឈ្មោះជាមួយ {parts}",
  "settings.navigation-back-button": "ត្រឡប់ក្រោយ",
  "settings.subtitle": "ធ្វើបច្ចុប្បន្នភាពការកំណត់គណនីរបស់អ្នក",
  "settings.title": "ការកំណត់គណនី",
  "settings.password.title": "ផ្លាស់ប្តូរពាក្យសម្ងាត់",
  "settings.password.description": "កែប្រែពាក្យសម្ងាត់របស់អ្នក",
  "settings.profile.title": "ការកំណត់ប្រវត្តិរូប",
  "settings.profile.description": "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានប្រវត្តិរូបរបស់អ្នក",
  "settings.webauthn.title": "គ្រប់គ្រងនិមិត្តសញ្ញាផ្នែករឹង",
  "settings.webauthn.description": "គ្រប់គ្រងការកំណត់និមិត្តសញ្ញាផ្នែករឹងរបស់អ្នក",
  "settings.messages.toast-title.success": "ការកំណត់ត្រូវបានធ្វើបច្ចុប្បន្នភាព",
  "settings.messages.toast-title.error": "មិនអាចធ្វើបច្ចុប្បន្នភាពការកំណត់បានទេ",
  "verification.title": "ផ្ទៀងផ្ទាត់គណនីរបស់អ្នក",
  "verification.subtitle": "បញ្ចូលអាសយដ្ឋានអ៊ីមែលដែលភ្ជាប់ជាមួយគណនីរបស់អ្នកដើម្បីផ្ទៀងផ្ទាត់វា",
  "two-step.password.title": "ពាក្យសម្ងាត់",
  "two-step.password.description": "បញ្ចូលពាក្យសម្ងាត់ដែលភ្ជាប់ជាមួយគណនីរបស់អ្នក",
  "two-step.code.title": "លេខកូដអ៊ីមែល",
  "two-step.code.description": "លេខកូដផ្ទៀងផ្ទាត់នឹងត្រូវបានផ្ញើទៅអ៊ីមែលរបស់អ្នក",
  "two-step.webauthn.title": "កូនសោរសុវត្ថិភាព",
  "two-step.webauthn.description": "ប្រើកូនសោរសុវត្ថិភាពរបស់អ្នកដើម្បីផ្ទៀងផ្ទាត់",
  "two-step.passkey.title": "Passkey (ណែនាំ)",
  "two-step.passkey.description": "ប្រើឧបករណ៍របស់អ្នកសម្រាប់ស្នាមម្រាមដៃ ឬការទទួលស្គាល់មុខ",
  "two-step.passkey.description.error": "មិនអាចផ្ទុកបណ្ណាល័យចាំបាច់ដើម្បីប្រើ Passkey របស់អ្នកបានទេ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
  "two-step.totp.title": "ប្រើកម្មវិធីផ្ទៀងផ្ទាត់របស់អ្នក (TOTP)",
  "two-step.totp.description": "ប្រើលេខកូដមួយដង 6 ខ្ទង់ពីកម្មវិធីផ្ទៀងផ្ទាត់របស់អ្នក",
  "two-step.lookup_secret.title": "លេខកូដស្តារបម្រុង",
  "two-step.lookup_secret.description": "ប្រើលេខកូដបម្រុង 8 ខ្ទង់មួយរបស់អ្នកដើម្បីផ្ទៀងផ្ទាត់",
  "input.placeholder": "បញ្ចូល {placeholder} របស់អ្នក",
  "card.header.parts.oidc": "អ្នកផ្តល់សេវាសង្គម",
  "card.header.parts.password.registration": "{identifierLabel} និងពាក្យសម្ងាត់របស់អ្នក",
  "card.header.parts.password.login": "{identifierLabel} និងពាក្យសម្ងាត់របស់អ្នក",
  "card.header.parts.code": "លេខកូដមួយដង",
  "card.header.parts.passkey": "Passkey",
  "card.header.parts.webauthn": "កូនសោរសុវត្ថិភាព",
  "card.header.parts.totp": "កម្មវិធីផ្ទៀងផ្ទាត់របស់អ្នក",
  "card.header.parts.lookup_secret": "លេខកូដស្តារបម្រុង",
  "card.header.parts.identifier-first": "{identifierLabel} របស់អ្នក",
  "misc.or": "ឬ",
  "forms.label.forgot-password": "ភ្លេចពាក្យសម្ងាត់?",
  "forms.label.recover-account": "ស្តារគណនី",
  "settings.totp.title": "កម្មវិធីផ្ទៀងផ្ទាត់",
  "settings.totp.description": "បន្ថែមកម្មវិធីផ្ទៀងផ្ទាត់ TOTP ទៅគណនីរបស់អ្នកដើម្បីកែលម្អសុវត្ថិភាពគណនីរបស់អ្នក។ កម្មវិធីផ្ទៀងផ្ទាត់ពេញនិយមមាន LastPass និង Google Authenticator",
  "settings.totp.info.not-linked": "ដើម្បីបើកសូមស្កេនលេខកូដ QR ជាមួយកម្មវិធីផ្ទៀងផ្ទាត់របស់អ្នក ហើយបញ្ចូលលេខកូដ។",
  "settings.totp.info.linked": "បច្ចុប្បន្នអ្នកមានកម្មវិធីផ្ទៀងផ្ទាត់ដែលបានភ្ជាប់។",
  "settings.lookup_secret.title": "លេខកូដស្តារបម្រុង (កត្តាទីពីរ)",
  "settings.lookup_secret.description": "លេខកូដស្តារគឺជាការបម្រុងសុវត្ថិភាពសម្រាប់ 2FA ដែលអនុញ្ញាតឲ្យអ្នកចូលប្រើគណនីរបស់អ្នកឡើងវិញប្រសិនបើអ្នកបាត់បង់ឧបករណ៍ 2FA របស់អ្នក។",
  "settings.oidc.title": "គណនីដែលបានភ្ជាប់",
  "settings.oidc.description": "ភ្ជាប់អ្នកផ្តល់សេវាចូលសង្គមជាមួយគណនីរបស់អ្នក។",
  "settings.oidc.info": "គណនីដែលបានភ្ជាប់ពីអ្នកផ្តល់សេវាទាំងនេះអាចត្រូវបានប្រើដើម្បីចូលទៅគណនីរបស់អ្នក",
  "settings.webauthn.info": "និមិត្តសញ្ញាផ្នែករឹងត្រូវបានប្រើសម្រាប់ការផ្ទៀងផ្ទាត់កត្តាទីពីរ ឬជាកត្តាទីមួយជាមួយ Passkeys",
  "settings.passkey.title": "គ្រប់គ្រង Passkeys",
  "settings.passkey.description": "គ្រប់គ្រងការកំណត់ passkey របស់អ្នក",
  "settings.passkey.info": "គ្រប់គ្រងការកំណត់ passkey របស់អ្នក",
  "card.footer.select-another-method": "ជ្រើសរើសវិធីផ្សេង",
  "account-linking.title": "ភ្ជាប់គណនី",
  "property.password": "ពាក្យសម្ងាត់",
  "property.email": "អ៊ីមែល",
  "property.phone": "ទូរស័ព្ទ",
  "property.username": "ឈ្មោះអ្នកប្រើ",
  "property.identifier": "លេខសម្គាល់",
  "property.code": "លេខកូដ",
  "property.recovery_address": "អាសយដ្ឋានស្តារ",
  "consent.title": "អនុញ្ញាត {party}",
  "consent.subtitle": "កម្មវិធីភាគីទីបីចង់ចូលប្រើព័ត៌មានដែលភ្ជាប់ជាមួយគណនីរបស់អ្នក {identifier}។",
  "consent.scope.openid.title": "អត្តសញ្ញាណ",
  "consent.scope.openid.description": "អនុញ្ញាតឲ្យកម្មវិធីផ្ទៀងផ្ទាត់អត្តសញ្ញាណរបស់អ្នក។ នេះចាំបាច់សម្រាប់ការផ្ទៀងផ្ទាត់ និងបទពិសោធន៍ចូលដែលអាចទុកចិត្តបាន។",
  "consent.scope.offline_access.title": "ការចូលប្រើក្រៅបណ្តាញ",
  "consent.scope.offline_access.description": "អនុញ្ញាតឲ្យកម្មវិធីនេះរក្សាអ្នកឲ្យចូលបានទោះបីអ្នកមិនកំពុងប្រើវាយ៉ាងសកម្មក៏ដោយ។",
  "consent.scope.profile.title": "ព័ត៌មានប្រវត្តិរូប",
  "consent.scope.profile.description": "អនុញ្ញាតការចូលប្រើព័ត៌មានប្រវត្តិរូបមូលដ្ឋានរបស់អ្នក រួមទាំងឈ្មោះអ្នកប្រើ នាមខ្លួន និងនាមត្រកូលរបស់អ្នក។",
  "consent.scope.email.title": "អាសយដ្ឋានអ៊ីមែល",
  "consent.scope.email.description": "ទាញយកអាសយដ្ឋានអ៊ីមែល និងស្ថានភាពផ្ទៀងផ្ទាត់របស់វា។",
  "consent.scope.address.title": "អាសយដ្ឋានជាក់ស្តែង",
  "consent.scope.address.description": "ចូលប្រើអាសយដ្ឋានប្រៃសណីយ៍របស់អ្នក។",
  "consent.scope.phone.title": "លេខទូរស័ព្ទ",
  "consent.scope.phone.description": "ទាញយកលេខទូរស័ព្ទ និងស្ថានភាពផ្ទៀងផ្ទាត់របស់វា។",
  "error.title.what-happened": "មានអ្វីកើតឡើង?",
  "error.title.what-can-i-do": "ខ្ញុំអាចធ្វើអ្វីបាន?",
  "error.instructions": "សូមព្យាយាមម្តងទៀតក្នុងរយៈពេលប៉ុន្មាននាទី ឬទាក់ទងអ្នកដំណើរការគេហទំព័រ។",
  "error.footer.text": "នៅពេលរាយការណ៍កំហុសនេះ សូមរួមបញ្ចូលព័ត៌មានដូចខាងក្រោម៖",
  "error.footer.copy": "ចម្លង",
  "error.action.go-back": "ត្រឡប់ក្រោយ",
  "identities.messages.4000039": "ពាក្យសម្ងាត់ថ្មីត្រូវតែខុសពីពាក្យសម្ងាត់ចាស់។",
  "identities.messages.4000040": "បញ្ចូលអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវ",
  "identities.messages.4000041": "បញ្ចូលលេខទូរស័ព្ទត្រឹមត្រូវ",
  "captcha.error": "ការផ្ទៀងផ្ទាត់សុវត្ថិភាពបានបរាជ័យ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។ ប្រសិនបើបញ្ហានៅតែបន្ត សូមទាក់ទងជំនួយ។",
  "identities.messages.5000002": "មិនមានវិធីបញ្ជាក់អត្តសញ្ញាណដែលអាចប្រើបានទេ។ សូមទំនាក់ទំនងជាមួយអ្នកគ្រប់គ្រងប្រព័ន្ធ។",
  "identities.messages.4010011": "គណនីនេះត្រូវបានហាមឃាត់ជាបណ្ដោះអាសន្ន។ សូមទំនាក់ទំនងទៅក្រុមជំនួយដើម្បីទទួលបានជំនួយ។",
  "identities.messages.1070018": "អ៊ីមែល ឬលេខទូរស័ព្ទ",
  "identities.messages.1080004": "សារល្មមដែលផ្ទុកលេខកូដផ្ទៀងផ្ទាត់បាន​ផ្ញើ​ទៅ​កាន់​លេខ​ទូរស័ព្ទ​ដែល​អ្នក​បាន​បញ្ជូន។ ក្នុង​ករណី​ដែល​អ្នក​មិន​ទាន់​ទទួល​បាន​សារល្មម​នោះ​ទេ សូម​ពិនិត្យ​មើល​ការ​វាយ​អក្ខរា​ក្រ​លេខ​នោះ ហើយ​ត្រូវ​ប្រាកដ​ថា​អ្នក​កំពុង​ប្រើ​លេខ​ដែល​អ្នក​បាន​ចុះ​ឈ្មោះ។",
  "identities.messages.1080005": "អ្នកបានបញ្ជាក់លេខទូរស័ព្ទរបស់អ្នកដោយជោគជ័យ។",
  "identities.messages.5000003": "អង្គការរបស់លោកអ្នកត្រូវការការផ្ទៀងផ្ទាត់តាមរយៈ SSO ប៉ុន្តែមិនបានកំណត់អ្នកផ្ដល់សេវា SSO ទេ។ សូមទាក់ទងអ្នកគ្រប់គ្រងប្រព័ន្ធ។",
  "identities.messages.1010024": "ចូល​ដោយ​ប្រើ​ឧបករណ៍​បញ្ជាក់",
  "identities.messages.1010025": "កូដមួយត្រូវបានផ្ញើទៅអាសយដ្ឋានរបស់អ្នក។ ប្រសិនបើអ្នកមិនបានទទួលវាទេ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4000042": "អ្នកមិនបានតំរៀបឧបករណ៍ DeviceAuthn ទេ។",
  "identities.messages.4000043": "ការចូលឆាកដោយប្រើប្រព័ន្ធបញ្ជាក់អត្តសញ្ញាណតាមអ៊ីនធឺណិតដែលបានផ្តល់ឱ្យមិនត្រឹមត្រូវទេ សូមព្យាយាមម្តងទៀត។",
  "identities.messages.4000044": "លិខិតស្នាម DeviceAuthn ដែលបានផ្តល់ជូន មិនត្រឹមត្រូវ។",
  "identities.messages.4050002": "អ្នកអាចផ្លាស់ប្តូរបានតែអាសយដ្ឋានមួយប៉ុណ្ណោះក្នុងមួយពេល។ សូមធ្វើការកែប្រែអាសយដ្ឋាននីមួយៗដោយឡែក។"
}
